module.exports = Object.freeze({
    logo:{
        VALIDATE_FILE_TYPES:['image/jpg', 'image/jpeg', 'image/png','image/svg+xml']
    }
})